<template>
  <main >
    <div class="main-container">
      <div class="row">
        <div class="col s12 l10 offset-l1 card-panel ">
          <div class=" center-align">
            <span class="titulo">Usuarios</span>
          </div>
          <div class="col s12 center-align margen-titulo">
            <span class="titulo">{{ computedList.length }} registros</span>
          </div>

          <div id="app">
            <div class="col s12 right-align">
              <div
                class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                @click="toggleFiltros"
                data-position="top"
                :data-tooltip="mostrarFiltros ? 'Ocultar Filtros' : 'Mostrar Filtros'"
            >
              <link
                  rel="stylesheet"

                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />
              <span 
              class="material-symbols-outlined btn-style" >
              {{ mostrarFiltros ? 'filter_alt' : 'filter_alt_off' }}
            </span>
            </div>
              <div
                  class="waves-effect waves-light btn tooltipped blue-grey darken-3"
                  @click="newUser"
                  id="newUSer"
                  data-position="top"
                  data-tooltip="Agregar Usuario"
              >
                <link
                    rel="stylesheet"
                    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
                />
                <span class="material-symbols-outlined btn-style">
                
              </span>
              </div>
              <div
                  class="waves-effect waves-light btn tooltipped blue-grey darken-3"
                  @click="generarExcel"
                  data-position="top"
                  data-tooltip="Generar Excel"
              >
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
              </div>
            </div>

            <div class="row" v-show="mostrarFiltros" v-if="!isBisvi">
              <div
                  class="column col offset-s1 s10 m6 l4 xl3"
                  v-for="titulo in titulos"
                  style="width: 14%"
              >
                <div class="chips validate input-filtros" :id="titulo.llave">
                  <!--               <i class="material-icons icon-chips">filter_list</i> -->
                  <input
                      class="chip-input"
                      :id="'input-' + titulo.llave"
                      @focusout="handleFocusOut(titulo.llave)"
                  />
                </div>
              </div>
            </div>
            <div class="row" v-show="mostrarFiltros" v-else>
              <div
                  class="column col offset-s1 s10 m6 l4 xl3"
                  v-for="titulo in titulos"
                  style="width: 14%"
              >
                <div class="chips validate input-filtros" :id="titulo.llave">
                  <input
                      class="chip-input"
                      :id="'input-' + titulo.llave"
                      @focusout="handleFocusOut(titulo.llave)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col s12 l10 offset-l1 card-panel " style="position: relative; border-radius: 10px;"
        >
          <table
              class="responsive-table striped highlight "
              style="text-align-last: center"
          >
            <thead>
            <tr>
              <th>#</th>
              <th v-for="titulo in titulos">
                <div>
                  {{ titulo.valor }}
                </div>
                <!--               <div class="input-field">
                  <input
                    type="text"
                    class="validate input-filtros"
                    :id="titulo.llave"
                    :placeholder="titulo.valor"
                    @input="filtro"
                  />
                </div> -->
              </th>
              <th v-if="isPermisosMonto">Permiso Monto</th>
              <th v-if="isPermisoActivacion">Activar</th>
              <th>Editar</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(fila, index) in agregar100">
              <td>{{index +1}}</td>
              <td>{{ fila.username }}</td>
              <td>{{ fila.nombre }}</td>
              <td>
                {{
                  fila.nivel
                }}
              </td>
              <td>{{ fila.lider == 0 ? "Sin Lider" : fila.lider }}</td>
              <td>{{ fila.cliente == 0 ? "Sin Cliente" : fila.cliente }}</td>
              <td>
                {{
                  fila.phoneNumber != "null" ? fila.phoneNumber : "sin Telefono"
                }}
              </td>
              <td>{{ fila.maxRecargas }}</td>
              <td v-if="isPermisosMonto"><div class="switch">
                <label>
                  <input type="checkbox" :checked="fila.isMonto==1" @change="cambiaPermiso(fila.username, fila.isMonto)">
                  <span class="lever"></span>
                </label>
              </div></td>
              <td v-if="isPermisoActivacion"><div class="switch">
                <label>
                  <input type="checkbox" :checked="fila.is_activo==1" @change="cambiaActivo(fila.username, fila.is_activo)">
                  <span class="lever"></span>
                </label>
              </div></td>
              <td v-if="miNivel != 3" class="center-align">
                <i
                    style="cursor: pointer"
                    class="fa fa-pencil-alt"
                    @click="editar(fila)"
                    aria-hidden="true"
                ></i>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import { getClientes, getLideres, getUsuarios, creaExcel, getUsuariosMonto, setUsuariosMonto, setUsuariosActivo } from "@/api/api";
import {permisos} from "@/constantes";
let filtros = {};
let isFrist = 0;

export default {
  name: "listUsers",

  data() {
    return {
      isEdit: false,
      titulo: "Cargando...",
      titulos: [
        { llave: "username", valor: "Username" },
        { llave: "nombre", valor: "Nombre" },
        { llave: "nivel", valor: "Nivel" },
        { llave: "lider", valor: "Líder" },
        { llave: "cliente", valor: "Cliente" },
        { llave: "phoneNumber", valor: "Teléfono" },
        { llave: "maxRecargas", valor: "Max Recargas" },
      ],
      isPermisoActivacion: false,
      mostrarExcel: false,
      cuerpos: [],
      filaEditar: "0",
      iccEdit: "",
      dnEdit: "",
      montoEdit: "",
      liderEdit: "",
      clienteEdit: "",
      miNivel: "",
      isPlataforma: false,
      noveces: 0,
      chips: [],
      chipsOptions: {
        onChipAdd: this.addChip,
        onChipDelete: this.deleteChip,
      },
      datosRecibios: [],
      datosAMostrar: [],
      indexScroll: 1,
      mostrarFiltros: true,
      isBisvi: false,
      isPermisosMonto: false
    };
  },
  created() {
    // M.AutoInit()
  },

  mounted() {
    console.log("eee2");
    this.miNivel = localStorage.nivel;
    this.cuerpos = [];
    this.datosRecibios = [];
    this.datosAMostrar = [];
    filtros = {};
    this.nivel = this.miNivel === "2" ? "3" : "1";
    this.nivelEditar = this.miNivel === "2" ? "3" : "1";
    this.selectedLiderEditar = localStorage.lider;
    this.isPermisoActivacion = localStorage.username == `demo` || localStorage.username == `discovery`
    this.$nextTick(() => {
      setTimeout(()=>{
        this.isPermisosMonto =
            (localStorage.getItem("permisos") + "").includes(permisos.PERMISO_MONTOS) &&
            this.miNivel == 1;

            this.getUsers();
            M.AutoInit();
            this.initChips();
            M.updateTextFields();

      }, 800)
      
        $(window).scroll(() => {
          if (
            $(document).height() <
            $(window).scrollTop() + $(window).height() + 20
          ) {
            this.indexScroll++;
          }
        });


    });
  },

  methods: {
    cambiaPermiso(username, isMonto){
      setUsuariosMonto(username, !isMonto)
          .then((respuesta) => {
            // this.usuarios=respuesta.usuarios
            this.datosRecibios.find(user => user.username == username).isMonto = !isMonto
            if(username == localStorage.username)
              localStorage.setItem('isMonto', !isMonto ? 1 : 0)
            console.log(respuesta)
          })
          .catch((error) => {
            console.log(error);
          });
    },
    cambiaActivo(username, isActivo){
      console.log(isActivo, `cambiar`)
      setUsuariosActivo(username, !isActivo)
          .then((respuesta) => {
            // this.usuarios=respuesta.usuarios
            this.datosRecibios.find(user => user.username == username).is_activo = !isActivo
            if(username == localStorage.username)
              console.log(`aqui`)
              //
            console.log(respuesta)
          })
          .catch((error) => {
            console.log(error);
          });
    },
    toggleFiltros() {
      this.mostrarFiltros = !this.mostrarFiltros;
    },
    handleFocusOut(llave) {
      const inputId = "input-" + llave;
      const input = document.getElementById(inputId);
      input.dispatchEvent(
        new KeyboardEvent("keydown", {
          key: "Enter",
          code: "Enter",
          keyCode: 13,
          which: 13,
        })
      );
    },

      initChips() {
      this.titulos.forEach((titulo) => {
        const elems = document.getElementById(titulo.llave);
        console.log("elems :" + elems);
        const chipsOptions = {
          ...this.chipsOptions,
          key: titulo.llave,
          placeholder: `${titulo.valor}`,
        };
        const chip = M.Chips.init(elems, chipsOptions);
      });
    },

    deleteChip(a, b) {
      const key = a[0].M_Chips.options.key;
      const value = b.firstChild.textContent;
      this.chips = this.chips.filter(
        (c) => !(c.key === key && c.value === value)
      );
      console.log(this.chips);
    },
    addChip(a, b) {
      const key = a[0].M_Chips.options.key;
      const value = b.firstChild.textContent;
      this.chips.push({ key, value });
      console.log(this.chips);
    },
    editar(fila) {
      this.$router.push({ name: "editarUsuario", params: { id: fila.id } });
    },
    /*     filtro(evento) {
      filtros[evento.target.id] = evento.target.value;
      this.cuerpos = [];
      this.datosAMostrar = this.datosRecibios.slice();
      Object.keys(filtros).forEach((llave) => {
        const auxFiltro = filtros[llave];
        if (auxFiltro !== "")
        this.datosAMostrar = this.datosAMostrar.filter((fila) =>
            fila[llave].toLowerCase().includes(auxFiltro.toLowerCase())
          );
      });
      this.titulo = `${datosAMostrar.length} encontrados`;
    }, */
    getUsers() {
      if(this.isPermisosMonto)
        getUsuariosMonto()
            .then((respuesta) => {
              respuesta.usuarios = respuesta.usuarios.map(r => {
                return{
                  ... r,
                  nivel: r.nivel == 1
                      ? "Administrador"
                      : r.nivel == 2
                      ? "Lider"
                      : "Cliente"
                }
              })
              // this.usuarios=respuesta.usuarios
              console.log(respuesta, `esta es`)
              console.log(respuesta, `esta es`)
              this.datosRecibios = respuesta.usuarios.slice();
              this.datosAMostrar = respuesta.usuarios.slice();
            })
            .catch((error) => {
              console.log(error);
            });
      else
        getUsuarios()
          .then((respuesta) => {
              respuesta.usuarios = respuesta.usuarios.map(r => {
                return{
                  ... r,
                  nivel: r.nivel == 1
                      ? "Administrador"
                      : r.nivel == 2
                      ? "Lider"
                      : "Cliente"
                }
              })
            // this.usuarios=respuesta.usuarios

            this.datosRecibios = respuesta.usuarios.slice();
            this.datosAMostrar = respuesta.usuarios.slice();
          })
          .catch((error) => {
            console.log(error);
          });
    },
    newUser() {
      let instance = M.Tooltip.getInstance(document.getElementById('newUSer'))
      instance.close()
      this.$router.push({ name: "addUsuario" });
    },
    generarExcel() {
      console.log("por generar excel loco");
      this.$store.commit("ponerBarra");

      creaExcel(this.chips, "USUARIOS")
        .then((response) => {
          this.$store.commit("quitarBarra");
          if (window.location.href.includes("recargasasec.com")) {
            console.log(process.env.NODE_ENV);

            window.location =
              process.env.NODE_ENV == "productionCam"
                ? `https://recargasasec.com/excel?nombre=${response.data.nombreArchivo}`
                : `http://localhost:8091/excel?nombre=${response.data.nombreArchivo}`;
          } else {
            window.location =
              process.env.NODE_ENV === "production"
                ? `https://recarga-te.com/excel?nombre=${response.data.nombreArchivo}`
                : `http://localhost:8091/excel?nombre=${response.data.nombreArchivo}`;
          }
        })
        .catch((error) => {
          this.$store.commit("quitarBarra");
          console.log(error);
          M.toast({
            html: "No se pudo crear el excel",
            classes: "rounded",
            displayLength: 3000,
          });
        });
    },
  },
  computed: {
    computedList() {
      this.datosAMostrar = this.datosRecibios.slice();
      console.log(this.titulo);
      if (this.chips.length) {
        let auxChips = this.chips.slice();
        let chipsArray = [];
        while (auxChips.length) {
          let chip = auxChips[0];
          chipsArray.push(
            auxChips.filter((auxChip) => auxChip.key == chip.key)
          );
          auxChips = auxChips.filter((auxChip) => auxChip.key != chip.key);
        }
        let auxDatosAMostrar = this.datosAMostrar.slice();
        chipsArray.forEach((element) => {
          auxDatosAMostrar = auxDatosAMostrar.filter((item) => {
            return element.some((titulo) => {
              return item[titulo.key]
                .toUpperCase()
                .includes(titulo.value.toUpperCase());
            });
          });
        });
        this.datosAMostrar = auxDatosAMostrar;
      }
      return this.datosAMostrar;
    },
    agregar100() {
      return this.computedList.slice(0, 20 * this.indexScroll);
    },
    /*     agregar100() {
      this.noveces++;

      this.cuerpos = this.cuerpos.concat(datosAMostrar.slice(0, 200));
      datosAMostrar.splice(0, 200);
    }, */
  },
};
</script>

<style scoped>
.wobble-hor-bottom:hover {
  -webkit-animation: pulsate-fwd 0.5s ease-in-out infinite both;
  animation: pulsate-fwd 0.5s ease-in-out infinite both;
}
@-webkit-keyframes pulsate-fwd {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes pulsate-fwd {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.btn {
  width: 70px;
  text-align-last: center;
}
.btn-style {
  margin-top: 5px;
}
table.responsive-table thead tr th::before {
  content: "";
}
.titulo {
  font-weight: inherit;
  color: rgba(0, 0, 0, 0.623);
  font-size: 24px;
  margin-top: auto;
  margin-bottom: auto;
  list-style-type: none;
  display: inline-block;
  padding: 0.75rem 0 1rem;
  -webkit-animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@-webkit-keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
@keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}

.titulo-card {
  font-size: 2.5em;
  font-family: "Roboto", serif;
  margin-bottom: 10px;
}

table {
  background-color: #ffffff;
  border-radius: 0.5rem;
  margin-top: 0.5rem;
}

.chacalada1 {
  height: 100px;
  top: 80px;
}
.chacalada2 {
  height: 100px;
  top: 80px;
  right: 100px;
}
.card-panel {
  border-radius: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
  overflow: auto;
}


.main-container {
  width: 94%;
  margin: 0 auto;
}

@media (max-width: 800px) {
  table {
    font-size: 0.8rem;
  }

  th {
    height: 63px;
    max-height: 63px;
  }
  td {
    height: 63px;
    max-height: 63px;
  }

  .titulo {
    font-size: 2rem;
  }
}
</style>
